import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CrmEventAttendingStatus } from "@enums/crmEventAttendingStatus.enum";
import { CrmEventType } from "@enums/crmEventType.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { CrmEventService } from "@services/crmEvent.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-events",
	styleUrls: ["crmEvents.css"],
	templateUrl: "crmEvents.html"
})
export class CrmEventsAdminComponent {
	attendingStatuses: any[] = [];
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	eventTypes: any[] = [];
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "CRM Event";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];

	constructor(private router: Router, private toastService: ToastService, private itemService: CrmEventService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.eventTypes = GetPropertiesFromEnum(CrmEventType);
		this.attendingStatuses = GetPropertiesFromEnum(CrmEventAttendingStatus);
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() { this.router.navigate([`${this.itemUrl}/create`]); }

	checkGridExportPermissions() {
		this.protectedGridService.canExport("CrmEvents").subscribe((res: any) => { this.canExportGrid = res.response; });
	}

	deleteRow(e: any) {
		if (confirm("Are you sure you want to delete this event?")) {
			this.itemService.deleteSingleById(e.row.data.id).subscribe(
				() => { this.toastService.success("Event deleted!"); this.getItems(); },
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
		}
	}

	editRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]); }

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll().subscribe(
			(res: any) => { this.items = res.response.items; this.gridLoading = false; },
			(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "CrmEvents";
		this.exportLogService.logExport(logExport).subscribe();
	}

	viewRow(e: any) { this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]); }
}
